/** Logical UDO templates owned by Stable Links. */
export enum StableLinksWorkspaceCapabilityUdoTemplateKey {
    stableLink = "a5116c6a-105c-499c-bcb1-878c9e4c817e",
}
